import React from "react";
import { withStyles } from "material-ui/styles";
import { AppBar, Toolbar, IconButton } from "material-ui";
import MenuIcon from "material-ui-icons/Menu";
import AccountCircle from "material-ui-icons/AccountCircle";
import { Manager, Target } from "react-popper";

import HeaderMenu from "components/HeaderMenu";
import appLogo from "assets/images/logo.png";
import { isCustomerAdmin } from "utils/formatter";

const styles = theme => ({
  appBarRoot: {
    backgroundColor: theme.palette.primary.light
  },
  headerLeftItem: {
    flex: 1
  },
  logoButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    outline: "none"
  },
  appLogo: {
    height: 40,
    verticalAlign: "middle",
    borderRadius: 2
  },
  tempPasswordCaution: {
    marginRight: 20
  },
  userIcon: {
    marginRight: 3
  },
  icon: {
    color: "white"
  },
  loginInfo: {
    margin: "0 5px"
  },
  customerName: {
    fontSize: "0.8rem"
  },
  spacer: {
    height: 64
  }
});

const Header = props => {
  const {
    classes,
    customerName,
    loginName,
    isTempPassword,
    handleGoHome
  } = props;

  return (
    <div>
      <AppBar
        position="fixed"
        classes={{
          root: isCustomerAdmin() ? classes.appBarRoot : ""
        }}
      >
        <Toolbar>
          <div className={props.classes.headerLeftItem}>
            <button
              className={classes.logoButton}
              onClick={handleGoHome}
              title="ホームへ"
            >
              <img src={appLogo} alt="" className={classes.appLogo} />
            </button>
          </div>

          {isTempPassword && (
            <div className={classes.tempPasswordCaution}>
              <span role="img" aria-label="">
                ❗
              </span>画面右上のメニューからパスワードを変更して下さい
            </div>
          )}

          <AccountCircle className={classes.userIcon} />
          <div className={customerName ? classes.loginInfo : ""}>
            <div className={classes.customerName}>{customerName}</div>
            <div>{loginName}</div>
          </div>

          <Manager>
            <Target>
              <IconButton
                className={classes.icon}
                label="Menu"
                onClick={props.openMenu}
              >
                <MenuIcon />
              </IconButton>
            </Target>
            <HeaderMenu
              anchorEl={props.anchorEl}
              open={props.open}
              closeMenu={props.closeMenu}
              historyPush={props.historyPush}
              handleLogout={props.handleLogout}
            />
          </Manager>
        </Toolbar>
      </AppBar>

      <div className={classes.spacer} />
    </div>
  );
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx